export default "__VITE_ASSET__ff3df498__"